import { _api } from '../../utils/apiAxios';

/**
 * To update player subscription fields.
 **/
const updateSubscribe = async data => {
  const res = await _api.post('/player/update-subscribe', data);
  return res;
};

/**
 * To get player subscription fields.
 **/
const getSubscribeInfo = async () => {
  const res = await _api.get('/player/get-subscribe-info');
  if (res.data.IsSuccess) {
    return res.data.Data;
  }
  return res;
};

/**
 * To get player full details.
 **/
const getPlayerFullDetails = async () => {
  const res = await _api.get('/player/details-full');
  if (res.data.IsSuccess) {
    return res.data.Data;
  }
  return res;
};

/**
 * To update player details.
 **/
const updatePlayerDetails = data => {
  return _api.post('/player/update-player-details', data);
};

/**
 * To get player login details.
 **/
const getPlayerLoginDetails = () => {
  return _api.get('/player/login-details');
};

const getPlayerRolloverDetails = () => {
  return _api.get('/player/get-player-rollover');
};

export {
  updateSubscribe,
  getPlayerFullDetails,
  updatePlayerDetails,
  getSubscribeInfo,
  getPlayerLoginDetails,
  getPlayerRolloverDetails,
};
